import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
import { PaymentInformation } from '../local/payment.model';
import { BaseResponseHttp } from './commons.model';
import { PackageValidation } from './invoices-Pending';
import { PrescriptionNameInfo } from './prescriptionName';

export class IOrdersPendingRes extends BaseResponseHttp {
  response?: IPendingOrders[];
}

export class IPendingOrders {
  id: number;
  transactionId: string;
  createDate: string;
  totalProducts: number;
  totalPieces: number;
  totalCost: number | undefined;
  status: string | undefined;
  paymentMethod: PaymentInformation;
  imgPaymentMethod: string;
  isRecipeAuthorized: boolean;
  isPaymentProcessed: number;
  createName: string;
  pedidoId: string;
  isPaymentAuthorized: boolean;
  needsRecipe: boolean;
  comments: string;
  constructor() {
    this.id = 0;
    this.transactionId = StringConst.empty;
    this.totalProducts = 0;
    this.totalPieces = 0;
    this.imgPaymentMethod = StringConst.empty;
    this.isRecipeAuthorized = false;
    this.isPaymentProcessed = NumberCons.zero;
    this.createName = StringConst.empty;
    this.pedidoId = StringConst.empty;
    this.isPaymentAuthorized = BooleanCons.false;
    this.needsRecipe = BooleanCons.false;
    this.paymentMethod = new PaymentInformation();
    this.createDate = StringConst.empty;
    this.comments = StringConst.empty;
  }
}

export class PaymentMethodInfo {
  method: string;
  cardType: string;
  cardId: string;
  dueDate: string;
  id: number | undefined | string;
  isCaduced: boolean;
  imgMethod?: string;
  paymentMethodInfoImg: string;
  cardNumber: string;
  constructor() {
    this.cardId = StringConst.empty;
    this.method = StringConst.empty;
    this.cardType = StringConst.empty;
    this.dueDate = StringConst.empty;
    this.id = 0;
    this.isCaduced = false;
    this.paymentMethodInfoImg = StringConst.empty;
    this.cardNumber = StringConst.empty;
  }
}

export class AuthorizedOrder {
  transactionId: string;
  email: string;
  doctorName: string;
  namesPrescriptions: PrescriptionNameInfo[];
  constructor() {
    this.transactionId = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.namesPrescriptions = [];
  }
}
export enum PaymentMethodEnum {
  visa = 'visa',
  spei = 'bank_transfer_payment',
  oxxo = 'cash_payment',
  mastercard = 'mastercard',
  paynet = 'store',
  default = '',
  store = 'store',
  americanExpres = 'american_express',
  carnet = 'carnet',
}

export class BackOrderActionsButtons {
  order: IPendingOrders;
  actionType: BackOrderActions;

  constructor() {
    this.order = new IPendingOrders();
    this.actionType = BackOrderActions.default;
  }
}

export enum BackOrderActions {
  default,
  changePaymentMethod,
  seePaymentDetail,
  codeExpired,
  authorizationOrder,
  seeDetails,
  deleteOrder,
}

export class ViewCode {
  pedidos: string;
  constructor() {
    this.pedidos = StringConst.empty;
  }
}
